<template>
  <el-tabs
    type="border-card"
    :before-leave="beforeLeaveM"
    v-model="activeTab"
    @tab-click="handleTabClick"
  >
    <el-tab-pane
      v-for="(tab, index) in tabs"
      :key="index"
      :label="tab.label"
      :name="tab.name"
    >
      <rabbey-table
        :key="index"
        :ref="`table_${tab.name}`"
        :index-url="indexUrl"
        :headers="tab.headers"
        :actions="tab.actions"
        @get:data="getData"
        @push:action="handleCommand"
        :callback-index="callbackIndex"
      >
        <slot name="actions"></slot>
      </rabbey-table>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  name: "RabbeyTablesTabs",
  props: {
    /**
     * Tabs configuration.
     *
     * Example: tabs = [{label: "Tab 1", name: "tab1", items: [], headers: [], actions: []}]
     */
    tabs: {
      type: Array,
      required: true
    },
    /**
     * Tab active by default.
     */
    defaultTabActive: {
      type: String,
      required: false
    },
    /**
     * API url for querying table data.
     *
     * This is used in the table component.
     */
    indexUrl: {
      type: String,
      required: true
    },
    /**
     * Function to overwrite the query response process
     * to the API.
     *
     * This is used in the table component.
     */
    callbackIndex: {
      type: Function,
      required: false
    },
    getData: {
      type: Function,
      required: true
    }
  },
  data() {
    return { activeTab: "" };
  },
  created() {
    if (this.defaultTabActive !== undefined) {
      this.activeTab = this.defaultTabActive;
    } else {
      if (this.tabs !== undefined && this.tabs.length > 0) {
        this.activeTab = this.tabs[0].name;
      }
    }
  },
  methods: {
    /**
     * Captura el evento click en las acciones de la tabla
     * y luego emite este evento al padre de este componente.
     */
    handleCommand(command) {
      this.$emit("table:push-action", command);
    },
    beforeLeaveM(a, o) {
      this.$emit("tab:change", a, o);
    },
    rabbeyTable() {
      const table = this.$refs[`table_${this.activeTab}`];
      return table !== undefined ? table[0] : undefined;
    },
    handleTabClick() {
      this.rabbeyTable().emitGetData();
    }
  }
};
</script>

<style></style>
